<template>
  <!-- 删除监控-选择商品 -->
  <jd-dialog
    append-to-body
    title="选择商品"
    :visible="isShow"
    width="1134px"
    :before-close="popupClose">
    <div style="margin-top: -4px;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="按sku选择" name="second"></el-tab-pane>
        <el-tab-pane label="导入sku" name="3"></el-tab-pane>
        <el-tab-pane label="分组sku" name="4"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- 头部查询表单 -->
    <div class="headSearchForm" v-if="!leadIntoSku && !fenzuSku">
      <inputForm
        :inputData="inputData"
        ref="inputForm"
        @toParentVal="searchForm"
        :btnPosition1="true"></inputForm>
    </div>
    <!-- 选择商品区块 -->
    <div class="goodsContent" v-if="!leadIntoSku && !fenzuSku">
      <!-- 左边盒子 -->
      <div class="left">
        <div class="titleBox">
          <div class="tit">店内商品({{ total || 0 }})</div>
          <div>
            <jd-button label="更新" @click="updateGoods" type="text" />
            <jd-button
              label="按查询结果选择"
              v-if="!selectOne"
              style="margin-left: 8px"
              @click="selectAllshop"
              type="text" />
            <jd-button
              label="全选"
              v-if="!selectOne"
              style="margin-left: 8px"
              @click="selectAll()"
              type="text" />
          </div>
        </div>
        <!-- 商品滚动盒子 -->
        <div class="goodsScrollBox">
          <jd-loading-new v-if="tableLoading" />
          <template v-if="!tableLoading">
            <template v-if="goodsList.length == 0">
              <div class="noDataBox">
                <jd-image :src="$globalCdn + '/images/leftOrNoCxt.png'" />
                <span>暂无任何数据</span>
              </div>
            </template>
            <div
              class="goods"
              :class="{ isAdd: item.isAdd }"
              v-for="item in goodsList"
              :key="skuSearch ? item.skuId : item.wareId">
              <!-- <a :href="item.itemUrl" target="_blank"> -->
              <img
                :src="item.logo"
                class="avar"
                alt="商品图片"
                style="width: 48px" />
              <div class="desc">
                <a
                  :href="item.itemUrl"
                  target="_blank"
                  style="padding-top: 10px">
                  <p :title="item.wareTitle || item.skuName" class="goodsName">
                    {{ item.wareTitle || item.skuName }}
                  </p>
                </a>
                <div class="foot">
                  <div>
                    <span class="money">￥{{ item.jdPrice }}</span>
                    <span v-if="skuSearch" class="goodsId"
                      >sku ID:{{ item.skuId }}</span
                    >
                    <span v-else class="goodsId">商品ID:{{ item.wareId }}</span>
                  </div>
                </div>
              </div>
              <!-- </a> -->
              <div>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/add_icon.svg"
                  class="addIcon"
                  alt="添加icon"
                  @click="addGoods(item)" />
              </div>
            </div>
          </template>
          <!-- </div> -->
        </div>
        <!-- 分页 -->
        <div class="new-pagination-page">
          <el-pagination
            @size-change="handleLeftSizeChange"
            @current-change="handleLeftCurrentChange"
            :current-page="currentLeftPage"
            background
            small
            :page-sizes="[5, 10, 50, 100, 500, 1000]"
            :page-size="pageSizeLeft"
            :pager-count="5"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 右边盒子 -->
      <div class="right">
        <jd-loading v-if="selectedGoodsLoading" />
        <template v-if="!selectedGoodsLoading">
        <div class="titleBox">
          <span class="tit">已选商品（{{ selectedGoodsList.length }}）</span>
          <div>
            <jd-button @click="selectGoodsList()" type="blueText">选择分组</jd-button>
            <jd-button @click="saveGoodsList()" type="blueText">保存分组</jd-button>
            <jd-button @click="empty()" type="blueText">清空</jd-button>
          </div>
          <!-- <span
            class="clear"
            style="right: 102px; color: "
            @click="selectGoodsList()"
            >选择分组</span
          >
          <span class="clear" style="right: 42px" @click="saveGoodsList()"
            >保存分组</span
          >
          <span class="clear" @click="empty()">清空</span> -->
        </div>
        <!-- 商品滚动盒子 -->

        <div class="goodsScrollBox">
          <template v-if="selectedGoodsList.length == 0">
            <div class="noDataBox">
              <jd-image :src="$globalCdn + '/images/leftOrNoCxt.png'" />
              <span>暂无任何数据</span>
            </div>
          </template>
          <template>
            <div
              class="goods"
              :class="{ isAdd: item.isAdd }"
              v-for="(item, index) in showSelectedGoodsList"
              :key="skuSearch ? item.skuId : item.wareId">
              <img :src="item.logo" class="avar" alt="商品图片" />
              <div class="desc">
                <p
                  :title="item.wareTitle || item.skuName || item.title"
                  class="goodsName">
                  {{ item.wareTitle || item.skuName || item.title }}
                </p>
                <div class="foot">
                  <div>
                    <span class="money"
                      >￥{{ item.jdPrice || item.price }}</span
                    >
                    <span v-if="skuSearch" class="goodsId"
                      >sku ID:{{ item.skuId }}</span
                    >
                    <span v-else class="goodsId">商品ID:{{ item.wareId }}</span>
                  </div>
                </div>
              </div>
              <img
                v-if="!disabled && !isShowDesc"
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/clear_icon.svg"
                class="clearIcon"
                alt="添加icon"
                @click="clearGoods(item, index)" />
            </div>
          </template>
        </div>
        <!-- 分页 -->
        <div class="new-pagination-page">
          <el-pagination
            @size-change="handleRigthSizeChange"
            @current-change="handleRightCurrentChange"
            :current-page="currentRightPage"
            small
            :pager-count="5"
            background
            :page-sizes="[5, 10, 50, 100, 500, 1000]"
            :page-size="pageSizeRight"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="selectedGoodsList.length">
          </el-pagination>
        </div>
          </template>
      </div>
    </div>

    <!-- 导入sku -->
    <div v-if="leadIntoSku && !fenzuSku">
      <div style="margin-bottom: 16px; display: flex; flex-direction: column">
        <div style="margin-bottom: 16px; height: 16px">
          <img
            src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip/yello.png"
            style="width: 14px; height: 14px; margin-right: 8px"
            alt="" />
          <span style="color: #f89f39">导入的sku在sku列表选中及查看</span>
        </div>
        <div style="height: 16px">
          <el-radio v-model="SkuRadio" label="手动输入">手动输入</el-radio>
          <el-radio v-model="SkuRadio" label="上传文件">上传文件</el-radio>
        </div>
      </div>
      <div
        v-if="SkuRadio == '手动输入'"
        class="new-input-box"
        style="height: 282px">
        <el-input
          style="width: 400px"
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          placeholder="多个sku用英文逗号隔开或者一行一个"
          v-model="textareaSKU"></el-input>
      </div>
      <div
        v-if="SkuRadio == '上传文件'"
        style="margin-bottom: 200px; display: flex; flex-wrap: wrap">
        <el-upload
          action=""
          ref="upload"
          :on-exceed="refile"
          :on-success="handleSuccess"
          :show-file-list="true"
          :limit="1"
          :file-list="fileList"
          accept=".csv, .txt, .xls, .xlsx"
          :auto-upload="false">
          <jd-button slot="trigger" type="blue" label="选择文件" />
        </el-upload>
        <el-button style="color: #2768ff" type="text" @click.prevent="openExe"
          >下载导入模板></el-button
        >
      </div>
      <!-- <div class="footer">
        <div style="width: 100%;">
          <jd-button label="确认导入" style="margin: 0 16px;" @click="IntoSku" type="break" />
          <span>成功导入{{successSku}}个，失败{{errorSku}}个</span>
        </div>
      </div> -->
    </div>

    <!-- 分组sku -->
    <div v-if="fenzuSku">
      <groupSkuBox :venderId="venderId" />
    </div>

    <!-- 底部按钮 -->
    <div v-if="leadIntoSku && !fenzuSku" style="width: 100%">
      <jd-button style="margin: 0 16px 0 0" @click="IntoSku"
        >确认导入</jd-button
      >
      <span
        >成功导入<span style="color: #2768ff">{{ successSku }}</span
        >个，失败<span style="color: #2768ff">{{ errorSku }}</span
        >个</span
      >
      <jd-button type="blueText" style="margin: 0 16px 0 3px" @click="chaeckFail"
        >查看失败原因</jd-button
      >
    </div>
    <div slot="footer">
      <jd-button type="blue" @click="sure" :disabled="disabled" v-loading="sureLoading">确定</jd-button>
      <jd-button @click="cancel">取消</jd-button>
    </div>

    <!-- 保存分组 -->
    <jd-dialog
      width="500px"
      title="保存分组"
      :visible.sync="saveVisible"
      append-to-body>
      <div>
        <el-radio v-model="saveRadio" label="新建分组">新建分组</el-radio>
        <el-radio v-model="saveRadio" label="已有分组">已有分组</el-radio>
        <div
          style="display: flex; flex-wrap: nowrap; margin-top: 16px"
          v-if="saveRadio == '新建分组'">
          <div style="width: 100px; line-height: 32px;">
            <span style="color: red">*</span>分组名称：
          </div>
          <el-input
            placeholder="请输入分组名称"
            v-model="groupName"
            maxlength="20"
            show-word-limit />
        </div>
        <div
          style="display: flex; flex-wrap: nowrap; margin-top: 16px"
          v-if="saveRadio == '已有分组'">
          <div style="width: 100px; line-height: 32px;">
            <span style="color: red">*</span>选择分组：
          </div>
          <el-select v-model="selsectGroup" placeholder="请选择">
            <el-option
              v-for="item in groupOptions"
              :key="item.groupId"
              :label="item.groupName"
              :value="item.groupId"></el-option>
          </el-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <jd-button @click="saveSpuList()" type="blue"
          >确定</jd-button
        >
        <jd-button @click="saveVisible = false">取消</jd-button>
      </span>
    </jd-dialog>

    <!-- 选择分组弹窗 -->
    <jd-dialog
      style="z-index: 4000"
      width="800px"
      title="选择分组"
      :isShowSure="false"
      :isShowCancel="false"
      :visible.sync="selectVisible"
      append-to-body>
      <div>
        <jd-table
          :loading="tableLoding"
          :tableData="selectTable">
          <el-table-column prop="groupName" label="分组名称"> </el-table-column>
          <el-table-column prop="skuNum" label="所选sku数" width="180">
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <div
                style="
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                ">
                <!-- <span
                  @click="addGroup(scope.row.groupId)"
                  style="color: #2768ff; cursor: pointer"
                  >添加</span
                >
                <span
                  @click="delGroup(scope.row.groupId)"
                  style="color: #2768ff; margin-left: 12px; cursor: pointer"
                  >删除</span
                > -->
                <jd-button type="blueText" @click="addGroup(scope.row.groupId)">添加</jd-button>
                <jd-button type="blueText" @click="delGroup(scope.row.groupId)">删除</jd-button>
              </div>
            </template>
          </el-table-column>
        </jd-table>
      </div>
    </jd-dialog>

    <!-- 导入失败原因弹窗 -->
    <jd-dialog
      width="800px"
      title="导入失败原因"
      :isShowSure="false"
      :isShowCancel="false"
      :visible.sync="failVisible"
      append-to-body>
      <div v-loading="failLoading">
        <el-table :data="failSkuList" border style="width: 100%">
          <el-table-column prop="skuId" label="SKUID" align="center"></el-table-column>
          <el-table-column prop="failReason" label="失败原因" align="center"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <div style="margin-top: 20px; text-align: right;">
          <el-pagination
            @size-change="handleFailSizeChange"
            @current-change="handleFailCurrentChange"
            :current-page="failCurrentPage"
            background
            small
            :page-sizes="[5, 10, 20, 50]"
            :page-size="failPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="failTotal">
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <jd-button @click="failVisible = false">取消</jd-button>
      </span>
    </jd-dialog>
  </jd-dialog>
  <!-- </my-popup> -->
</template>

<script>
let apiModule = import("@/api/analysis/ware-controller.js");
// import {
//   getSellercats,
//   getTaobaoItemList,
//   getTaobaoItemListSku,
//   addToGroup,
//   getGroupList,
//   delSkuGroup,
//   getSkuListByGroup,
//   SKUinputText,
//   importSkuFile,
// } from "@/api/analysis/ware-controller";
// } from "@/api/jhk/analysis/ware-controller.js";
import myPopup from "./myPopup";
import inputForm from "./inputForm";
import groupSkuBox from "./groupSkuBox.vue";
import { synchroJdWare } from "@/api/serviceCenter/popCommentWareAnalysis";
import { checkProduct } from "@/api/jhk/activity.js";
import JdLoadingNew from './newComponents/Loading/jd-loading-new.vue';

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    selectGoods: {
      type: Array,
      default: () => {
        return [];
      },
    }, // 用于回显选中的商品
    moduleType: {
      type: Boolean,
      default: false,
    },
    skuSearch: {
      type: Boolean,
      default: false,
    },
    selectOne: {
      // 只能选择一个
      type: Boolean,
      default: false,
    },
    venderId: {
      type: Number | String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isShowDesc: {
      type: Boolean,
      default: false,
    },
    // 通过skuIds回显商品的使用参考 src/views/interactiveMarketing/activity/components/gifBagStyle.vue
    // 新增属性：用于通过skuIds字符串回显商品
    skuIdsString: {
      type: String,
      default: "",
    },
    echoByIds: {
      // 是否通过商品id回显
      type: Boolean,
      default: false,
    },
    // 限制商品
    isLimit: {
      type: Boolean,
      default: false,
    },
    // 限制商品数量
    limitNum: {
      type: Number,
      default: 20,
    },
    // 判断是否是修改活动，用于处理积分锁权进行中的活动修改奖品，不能移除已经上线的奖品
    isClear: {
      type: Boolean,
      default: false,
    },
    // 用于修改活动时，禁用已经选中的商品
    hasSelectGoods: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 判断是否是互动活动
    isInteract: {
      type: Boolean,
      default: false,
    },
    // 是否支持配置虚拟套组和影分身商品
    isSupportVirtualGroup: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isShow(newVal) {
      // if (newVal && !this.moduleType) {
      //   console.log(this.selectGoods, 123456);
      //   const ids =
      //     this.selectGoods && this.selectGoods.map((item) => +item.wareId);
      //   // debugger;
      //   this.goodsList.forEach((item) => {
      //     console.log(item);
      //     // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
      //     const state = ids.includes(item.wareId);
      //     const isrepeat = this.selectedGoodsList.find(
      //       (data) => data.wareId == item.wareId
      //     );
      //     console.log(this.selectedGoodsList, 155555555);
      //     //  this.selectedGoodsList.push(item);
      //     if (state && !isrepeat) {
      //       this.selectedGoodsList.push(item);
      //       item.isAdd = true;
      //       console.log(this.selectedGoodsList, 1666666);
      //     }
      //   });
      // }
      if (newVal && this.moduleType) {
        this.selectedGoodsList = JSON.parse(JSON.stringify(this.selectGoods));
        this.showSelectedGoodsList = JSON.parse(
          JSON.stringify(this.selectGoods)
        );
        if (this.skuSearch) {
          this.ids = this.selectGoods.map((i) => i.skuId+'');
        } else {
          this.ids = this.selectGoods.map((i) => i.wareId+'');
        }
        this.$nextTick(() => {
          this.$refs.inputForm.formSearch();
        });
        // console.log(this.selectGoods, this.ids);
      } else {
        // 清空搜索框
        this.$refs.inputForm.initVal();
      }
    },
    selectVisible(newVal) {
      if (newVal) {
        this.GroupList();
      }
    },
    // 监听skuIdsString变化，当有值时自动获取商品信息并回显
    skuIdsString: {
      handler(newVal) {
        if (newVal && this.isShow && this.echoByIds) {
          this.getGoodsBySkuIds(newVal);
        }
      },
      immediate: true,
    },
    selectedGoodsList: { // 回显
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.sliceArr(this.currentRightPage, this.pageSizeRight);
        }
      },
      immediate: true
    }
  },
  components: {
    myPopup,
    inputForm,
    groupSkuBox,
    JdLoadingNew,
  },
  data() {
    return {
      isSkuId: false,
      sureLoading: false,
      leadIntoSku: false,
      activeName: "second",
      // 1.11 保存分组
      saveRadio: "新建分组",
      groupName: "",
      groupOptions: [],
      selsectGroup: "",
      selectVisible: false,
      saveVisible: false,
      selectTable: [], //选择分组
      tableLoding: false,
      fenzuSku: false,
      // 1.11 导入sku
      filesuccess: false,
      leadIntoSku: false, //导入sku
      textareaSKU: "", //手动输入sku值
      successSku: 0,
      errorSku: 0,
      SkuRadio: "手动输入",
      fileList: [],

      inputData: [
        // 头部查询表单配置项
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          multiple: this.skuSearch,
          width: 260,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID, 多个请用,隔开",
          width: 260,
        },
        {
          name: "商品状态:",
          val: "wareStatus",
          default: "",
          selectArr: [
            { label: "全部", id: "" },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 260,
        },
        {
          name: "商品编码:",
          val: "wareIdStr",
          placeholder: "请输入商品编码，多个请用,隔开",
          width: 260,
        },
      ],
      total: 0,
      goodsList: [], // 左边店内商品数据

      currentLeftPage: 1, // 左边店内商品当前页

      selectedGoodsList: [], // 右边已选商品数据
      showSelectedGoodsList: [], // 右边显示已选商品

      currentRightPage: 1, // 右边已经商品当前页

      tableLoading: false, //左盒子loading
      ids: [], //已选商品id集合,防止同一个商品可被多次选中

      pageSizeLeft: 5,
      pageSizeRight: 5,
      allShopList: [],
      selectedGoodsLoading: false,
      // 导入失败相关
      failVisible: false, // 失败弹窗显示控制
      failUuid: "", // 导入返回的失败uuid，用于查询失败列表
      failSkuList: [], // 当前页失败sku列表
      failTotal: 0, // 失败总条数
      failLoading: false, // 失败列表loading
      failCurrentPage: 1, // 失败列表当前页
      failPageSize: 5, // 失败列表每页条数
    };
  },
  async created() {
    const routePath = this.$route.path;
    if (routePath.startsWith('/interactiveMarketing')||routePath.startsWith('/tool')||routePath.endsWith("/zhipuDecoration")) {
      this.isSkuId = false
      apiModule = import("@/api/jhk/analysis/ware-controller.js");
    }else  {
      this.isSkuId = true
      apiModule = import("@/api/analysis/ware-controller.js");
    }
    const api = await apiModule;
    this.getSellercats = api.getSellercats;
    this.getTaobaoItemList = api.getTaobaoItemList;
    this.getTaobaoItemListSku = api.getTaobaoItemListSku;
    this.addToGroup = api.addToGroup;
    this.getGroupList = api.getGroupList;
    this.delSkuGroup = api.delSkuGroup;
    this.getSkuListByGroup = api.getSkuListByGroup;
    this.SKUinputText = api.SKUinputText;
    this.importSkuFile = api.importSkuFile;
    this.getImportSkuFailList = api.getImportSkuFailList;

    if (this.moduleType) {
      // 修复回显时，selectedGoodsList为空导致报错
      this.selectedGoodsList = JSON.parse(JSON.stringify(this.selectGoods)) || [];
      // 处理积分锁权进行中的活动修改奖品，不能移除已经上线的奖品
      if(this.isClear&&this.hasSelectGoods.length>0) {
        this.selectedGoodsList.forEach((i) => {
          this.hasSelectGoods.forEach((j) => {
            if(j.skuId == i.skuId) {
              i.isAdd = true;
            }
          })
        })
      }
      // 将已选商品ID集合成ids数组
      // 修复回显时，为空导致报错
      if(this.selectGoods) {
        this.ids = this.selectGoods.map((i) => {
          if (i.skuId) {
            return i.skuId + "";
          } else {
            return i.wareId + "";
          }
        });
      }
    }
    // sku维度商品查询
    if (this.skuSearch) {
      // this.inputData.splice(3,1);
      this.inputData.splice(2, 1);

      this.inputData.splice(2, 0, {
        name: "商品状态:",
        val: "skuStatus",
        default: "",
        selectArr: [
          { label: "全部", id: "" },
          { label: "上架", id: 1 },
          { label: "下架", id: 2 },
        ],
        width: 260,
      });
      this.inputData.push({
        name: "商品名称:",
        val: "skuName",
        placeholder: "请输入商品名称",
        width: 260,
      });
    } else {
      this.inputData.push({
        name: "商品名称:",
        val: "wareTitle",
        placeholder: "请输入商品名称",
        width: 260,
      });
    }
    if (this.echoByIds && this.skuIdsString) {
      this.getGoodsBySkuIds(this.skuIdsString);
    }
    this.init();
    this.GroupList();
  },
  mounted() {
    // this.init(); //初始化
    console.log("回显选中商品==", this.selectedGoodsList, this.selectGoods);
    // this.GroupList();
    // 根据分页size截取数组
    this.sliceArr(this.currentRightPage, this.pageSizeRight);
  },
  methods: {
    // 查看失败原因 - 通过failUuid从接口获取失败列表
    chaeckFail(){
      if (!this.failUuid) {
        this.$message.warning("暂无失败数据");
        return;
      }
      this.failVisible = true;
      this.failCurrentPage = 1;
      this.getFailList();
    },
    // 获取导入失败列表数据
    getFailList() {
      this.failLoading = true;
      this.getImportSkuFailList({
        failUuid: this.failUuid,
        current: this.failCurrentPage,
        size: this.failPageSize
      }).then(res => {
        this.failLoading = false;
        if (res.code == 1) {
          this.failSkuList = res.data.records || res.data.list || [];
          this.failTotal = res.data.total || 0;
        } else {
          this.$message.error(res.message || "获取失败列表失败");
        }
      }).catch(() => {
        this.failLoading = false;
        this.$message.error("获取失败列表失败");
      });
    },
    // 失败列表分页 - 每页条数变化
    handleFailSizeChange(size) {
      this.failPageSize = size;
      this.failCurrentPage = 1;
      this.getFailList();
    },
    // 失败列表分页 - 当前页变化
    handleFailCurrentChange(page) {
      this.failCurrentPage = page;
      this.getFailList();
    },
    refile(file) {
      console.log(file[0]);
      this.$refs.upload.clearFiles();
      this.$refs.upload.handleStart(file[0]);
    },
    handleClick(tab) {
      if (tab.name == "second") {
        this.leadIntoSku = false;
        setTimeout(() => {
          this.$refs.inputForm.formSearch();
        }, 100);
      }
      if (tab.name == "3") {
        this.leadIntoSku = true;
      }
      if (tab.name == "4") {
        this.fenzuSku = true;
      } else {
        this.fenzuSku = false;
      }
    },
    // 添加商品
    addGroup(id) {
      this.getSkuListByGroup(id,this.venderId).then((res) => {
        if (res.code == 1) {
          res.data.forEach((item) => {
            let ispush = true;
            this.selectedGoodsList.forEach((it) => {
              if (it.skuId == item.skuId) {
                ispush = false;
              }
            });
            if (ispush) {
              this.addGoods(item);
            }
          });
          this.selectVisible = false;
          this.$refs.inputForm.formSearch();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      }).catch((error) => {
        console.error('获取商品组失败:', error);
        this.$message({
          type: "error",
          message: "获取商品组失败",
        });
      });
    },
    // 删除商品组
    delGroup(id) {
      this.$confirm("是否确认删除此分组?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delSkuGroup(id,this.venderId).then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.GroupList();
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 获取商品列表
     GroupList() {
      // let that = this
      this.tableLoding = true;
      this.getGroupList({
        venderId: this.venderId
      }).then(res => {
        if (res.code == 1) {
          if(res.data.length > 0) {
            this.groupOptions = res.data;
            this.selectTable = res.data;
          }
          this.tableLoding = false;
          console.log('8', this.groupOptions)
        } else {
          this.tableLoding = false;
        }
      });
    },

    // 保存sku分组
    saveSpuList() {
      let formData = {
        groupId: "",
        groupName: "",
        venderId: this.venderId,
        // idList:this.selectedGoodsList,
      };
      if (this.saveRadio == "新建分组") {
        if (this.groupName == "") {
          this.$message.warning("分组名称不可为空");
          return;
        }
        formData.groupName = this.groupName;
      }
      if (this.saveRadio == "已有分组") {
        if (this.selsectGroup == "") {
          this.$message.warning("请选择分组");
          return;
        }
        formData.groupId = this.selsectGroup;
        this.groupOptions.forEach((item) => {
          if (item.groupId == formData.groupId) {
            formData.groupName = item.groupName;
          }
        });
      }
      formData.idList = this.selectedGoodsList.map((item) => {
        return item.skuId;
      });
      this.addToGroup(formData).then((res) => {
        if (res.code == 1) {
          this.saveVisible = false;
          this.$message.success("创建成功");
          this.GroupList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 选择分组
    selectGoodsList() {
      this.selectVisible = true;
    },
    // 保存分组
    saveGoodsList() {
      this.saveVisible = true;
      this.groupName = "";
      this.selsectGroup = "";
    },

    // 下载模板文件
    openExe() {
      window.open(
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/SKU%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx",
        "_blank"
      );
    },
    // 导入文件
    handleSuccess() {
      this.filesuccess = true;
    },
    beforeUpload(file) {
      console.log("---file---");
      console.log(file);
      const fileSize = file.size / 1024 / 1024 < 50;
      if (!fileSize) {
        this.message.warning("上传模板大小不能超过 50MB!");
        return false;
      }
      let formData = new FormData();
      formData.append("file", file.raw);
      this.importSkuFile(formData,this.venderId).then((res) => {
        if (res.code == 1) {
          this.$message.success("导入成功！");
          this.$refs.upload.clearFiles();
          this.successSku = res.data.successNum;
          this.errorSku = res.data.failNum;
          // 保存失败uuid，用于查询失败列表
          this.failUuid = res.data.failUuid || "";
          res.data.skuList.forEach((item) => {
            let ispush = true;
            this.selectedGoodsList.forEach((it) => {
              if (it.skuId == item.skuId) {
                ispush = false;
              }
            });
            if (ispush) {
              this.addGoods(item);
            }
          });
          // this.$refs.inputForm.formSearch();
        } else {
          this.$message.error(res.message);
        }
      });
      return false;
    },
    // 导出sku
    IntoSku() {
      if (this.SkuRadio == "手动输入") {
        let lines = this.textareaSKU.split("\n");
        let finalArray = lines.flatMap((line) => line.split(","));
        finalArray = finalArray.map((item) => item.trim());
        let skuId = finalArray.join(",");
        this.SKUinputText({
          skuId: skuId,
          venderId: this.venderId,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("导入成功！");
            this.successSku = res.data.successNum;
            this.errorSku = res.data.failNum;
            // 保存失败uuid，用于查询失败列表
            this.failUuid = res.data.failUuid || "";
            res.data.skuList.forEach((item) => {
              let ispush = true;
              this.selectedGoodsList.forEach((it) => {
                if (it.skuId == item.skuId) {
                  ispush = false;
                }
              });
              if (ispush) {
                this.addGoods(item);
              }
            });
            // this.$refs.inputForm.formSearch();
          } else {
            this.$message.error(res.message);
          }
        });
      }
      if (this.SkuRadio == "上传文件") {
        this.beforeUpload(this.$refs.upload.uploadFiles[0]);
      }
    },

    init() {
      // 获取商品类目
      this.getSellercats().then((res) => {
        let data = this.transverter(res.data);
        // console.log(data);
        this.getTrees(data);
        // console.log(data);
        // debugger
        let list = data.filter((item) => item.parent_id == 0);
        // console.log('list',list);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        console.dir(cascaderArr);

        this.inputData[0].cascaderArr = cascaderArr;
        // console.log(this.inputData[0]);
      });
      this.$nextTick(() => {
        // 添加判断-解决报错
        this.$refs.inputForm && this.$refs.inputForm.formSearch();
      });
    },
    sure() {
      console.log("选中商品", this.selectedGoodsList,this.limitNum);
      if (this.isLimit && this.selectedGoodsList.length > this.limitNum) {
        return this.$message.warning(`选择商品不能超过${this.limitNum}个`);
      }
      this.selectedGoodsList.forEach((item) => {
        item.title = item.wareTitle || item.title || item.skuName;
      });
      const isActivity = this.$parent && this.$parent.activityData && this.$parent.activityData.id;
      console.log('isActivity',isActivity);
      if (this.isInteract || (isActivity != undefined || isActivity != null)) {
        const skuIds = this.selectedGoodsList.map((v) => v.skuId);
        if (skuIds.length == 0) {
          this.$emit("close", this.selectedGoodsList);
          return;
        }
        if(!this.isSupportVirtualGroup) {
          this.sureLoading = true;
          checkProduct(skuIds)
            .then((res) => {
              this.sureLoading = false;
              if (res.code == 1) {
                if (res.data.isHave) {
                  this.$message.warning("活动暂不支持选择虚拟套装和影分身商品");
                } else {
                  this.$emit("close", this.selectedGoodsList);
                }
              } else {
                this.$message.warning(res.message);
              }
            })
            .catch((err) => {
              console.log(err);
              this.sureLoading = false;
            });
        } else {
          this.$emit("close", this.selectedGoodsList);
        }
        return;
      }
      this.$emit("close", this.selectedGoodsList);
    },
    cancel() {
      this.$emit("close", false);
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },
    /**
     * 弹窗隐藏
     */
    popupClose() {
      this.$emit("close", false);
      this.fenzuSku = false;
      this.activeName = "1";
    },
    /**
     * 表单查询商品列表
     */
    searchForm(form) {
      this.tableLoading = true;
      form.current = this.currentLeftPage;
      console.log("form.categoryId:", form);
      form.categoryId =
        form.categoryId.length && Array.isArray(form.categoryId)
          ? form.categoryId.join(",")
          : form.categoryId;
      console.log(this.pageSizeLeft);
      if (this.skuSearch) {
        let param = {
          ...form,
          size: this.pageSizeLeft,
          venderId: this.venderId,
          skuIdStr: form.skuId,
        };
        if(param.skuIdStr&&!this.isSkuId){
          delete param.skuId
        }
        if(this.isSkuId) {
          delete param.skuIdStr
        }
        if (this.venderId) {
          param.venderId = this.venderId;
        }
        this.getTaobaoItemListSku(param).then((res) => {
          this.tableLoading = false;
          if (res.code == 1) {
            // console.log(res.data.records);
            res.data.records.map((item) => {
              item.wareTitle = item.skuName;
              item.isAdd = false
            });
            this.goodsList = res.data.records;
            if (this.moduleType) {
              this.goodsList.forEach((item) => {
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                const state = this.ids.includes(item.skuId+'');
                if (state) {
                  item.isAdd = true;
                }
              });
            }
            this.total = +res.data.total;
            //所有商品
            this.allShop(form, {current:param.current,size:param.size}, 1);
          } else {
            this.goodsList = [];
          }
        });
      } else {
        // console.log(this.pageSizeLeft);
        let param = {
          ...form,
          page: form.current,
          pageSize: this.pageSizeLeft,
          venderId: this.venderId,
        };
        if (this.venderId) {
          param.venderId = this.venderId;
        }
        this.getTaobaoItemList(param).then((res) => {
          console.log(res.data);
          this.tableLoading = false;
          if (res.data == null) {
            this.goodsList = [];
          }
          if (res.code == 1) {
            this.goodsList = res.data.records;
            if (this.moduleType) {
              this.goodsList.forEach((item) => {
                // console.log(item.wareId);
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                const state = this.ids.includes(item.wareId+'');
                // console.log(state);
                if (state) {
                  item.isAdd = true;
                }
                var itemUrlX = "";
                // 根据查询的skuId 设置跳转地址
                if (form.skuId) {
                  var skuList = item.skuList;
                  if (skuList) {
                    skuList.forEach((skuItem) => {
                      if (skuItem.skuId == form.skuId) {
                        itemUrlX = skuItem.itemUrl;
                      }
                    });
                  }
                }
                if (itemUrlX) {
                  item.itemUrl = itemUrlX;
                }
              });
              this.$forceUpdate();
              console.log("this.goodsList:", this.goodsList);
            }
            // function myIsNaN(value) {
            //     return typeof value === 'number' && !isNaN(value);
            // }
            this.sliceArr(this.currentRightPage, this.pageSizeRight);
            console.log(res.data.records);
            this.total = +res.data.total;
            //所有商品
            this.allShop(form, {current:param.current,size:this.pageSizeLeft}, 2);
          } else {
            this.goodsList = [];
          }
        });
      }
    },
    // 所有商品
    allShop(form, pageInfo, type) {
      if (type == 1) {
        let param = {
          ...form,
          current: pageInfo.current,
          size: pageInfo.size,
          venderId: this.venderId,
          skuIdStr: form.skuId,
        }
        if(param.skuIdStr&&!this.isSkuId){
          delete param.skuId
        }
        if(this.isSkuId) {
          delete param.skuIdStr
        }
        this.getTaobaoItemListSku(param).then((res) => {
          if (res.code == 1) {
            // console.log(res.data.records);
            res.data.records.map((item) => {
              item.wareTitle = item.skuName;
            });
            this.allShopList = res.data.records;
            if (this.moduleType) {
              this.allShopList.forEach((item) => {
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                const state = this.ids.includes(item.skuId+'');
                if (state) {
                  item.isAdd = true;
                }
              });
            }
          } else {
            this.allShopList = [];
          }
        });
      } else {
        this.getTaobaoItemList({
          ...form,
          page: pageInfo.current,
          pageSize: pageInfo.size,
          current: pageInfo.current,
          size: pageInfo.size,
          venderId: this.venderId,
        }).then((res) => {
          if (res.data == null) {
            this.allShopList = [];
          }
          if (res.code == 1) {
            this.allShopList = res.data.records;
            if (this.moduleType) {
              this.allShopList.forEach((item) => {
                // console.log(item.wareId);
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                const state = this.ids.includes(item.wareId+'');
                // console.log(state);
                if (state) {
                  item.isAdd = true;
                }
              });
            }
          } else {
            this.allShopList = [];
          }
        });
      }
    },
    /**
     * 更新商品
     */
    updateGoods() {
      // this.$refs.inputForm.formSearch();
      synchroJdWare().then((res) => {
        console.log(res);
        if (res.code == "1") {
          this.$message.success("正在同步店铺商品");
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    /**
     * 添加商品
     */
    addGoods(item) {
      if (this.disabled) return;
      if (item.isAdd) return;
      if (this.ids.length == 1 && this.selectOne)
        return this.$message.warning("只能选择一个商品！");
      item.isAdd = true;
      if (this.skuSearch) {
        this.ids.push(item.skuId+'');
        // 全部商品
        this.allShopList.forEach((i) => {
          if (i.skuId == item.skuId) {
            i.isAdd = true;
          }
        });
      } else {
        this.ids.push(item.wareId+'');
        // 全部商品
        this.allShopList.forEach((i) => {
          if (i.wareId == item.wareId) {
            i.isAdd = true;
          }
        });
      }
      this.selectedGoodsList.push({
        ...item,
        isAdd: false,
      });
      this.sliceArr(this.currentRightPage, this.pageSizeRight);
    },
    /**
     * 全选
     */
    selectAll() {
      this.goodsList.forEach((item) => {
        // feat:若有限制，当批量选择超过20个时会勾选前20个
        if (this.isLimit && this.selectedGoodsList.length >= this.limitNum) {
          this.$message.warning(`最多只能选择${this.limitNum}个商品！`)
          return;
        }
        if (!item.isAdd) {
          item.isAdd = true;
          this.selectedGoodsList.push({
            ...item,
            isAdd: false,
          });
          // sku维度
          if (this.skuSearch) {
            this.ids.push(item.skuId+'');
            this.allShopList.forEach((i) => {
              if (i.skuId == item.skuId) {
                i.isAdd = true;
              }
            });
          } else {
            this.ids.push(item.wareId+'');
            this.allShopList.forEach((i) => {
              if (i.wareId == item.wareId) {
                i.isAdd = true;
              }
            });
          }
        }
      });
      this.sliceArr(this.currentRightPage, this.pageSizeRight);
    },
    // 按结果全选
    selectAllshop() {
       let param = {
        ...this.$refs.inputForm.form,
        size: 99999,
      }
      param.skuIdStr = param.skuId
      if(param.skuIdStr&&!this.isSkuId){
        delete param.skuId
      }
      if(this.isSkuId) {
        delete param.skuIdStr
      }
      param.current = 1
      if(this.venderId){
        param.venderId = this.venderId
      }
      this.getTaobaoItemListSku(param).then(res=>{
        let selectData = res.data.records.map((item) => {
          item.wareTitle = item.skuName;
          return item
        });
        if (selectData.length >= 10000) {
            this.$message.warning("按结果选择商品不能超过10000个");
            return;
        }
        this.ids = [];
        this.selectedGoodsList = [];
        selectData.forEach((item) => {
        // feat:若有限制，当批量选择超过20个时会勾选前20个
          if (this.isLimit && this.selectedGoodsList.length >= this.limitNum){

          }else{
            this.selectedGoodsList.push(item);
             // sku维度
            if (this.skuSearch) {
              this.ids.push(item.skuId+'');
            } else {
              this.ids.push(item.wareId+'');
            }
          }
        });
        // this.goodsList中skuId在this.selectedGoodsList中存在则添加isAdd属性
        this.goodsList.forEach((item) => {
          if (this.selectedGoodsList.some((i) => i.skuId == item.skuId)) {
            item.isAdd = true;
          }
        });
        this.sliceArr(this.currentRightPage, this.pageSizeRight);
      })
    },
    /**
     * 左边商品盒子分页事件
     */
    handleLeftSizeChange(val) {
      this.pageSizeLeft = val;
      this.currentLeftPage = 1;
      this.$refs.inputForm.formSearch();
    },
    handleLeftCurrentChange(val) {
      this.currentLeftPage = val;
      this.$refs.inputForm.formSearch();
    },
    /**
     * 删除商品
     */
    clearGoods(item, index) {
      if (this.disabled) return;
      if(item.isAdd) {
        return
      }
      if (this.skuSearch) {
        this.goodsList.forEach((i) => {
          if (i.skuId == item.skuId) {
            i.isAdd = false;
          }
        });
        this.allShopList.forEach((i) => {
          if (i.skuId == item.skuId) {
            i.isAdd = false;
          }
        });
      } else {
        this.goodsList.forEach((i) => {
          if (i.wareId == item.wareId) {
            i.isAdd = false;
          }
        });
        this.allShopList.forEach((i) => {
          if (i.wareId == item.wareId) {
            i.isAdd = false;
          }
        });
      }
      if (this.moduleType) {
        if (this.skuSearch) {
          this.ids.splice(
            this.ids.findIndex((i) => i == item.skuId),
            1
          );
        } else {
          this.ids.splice(
            this.ids.findIndex((i) => i == item.wareId),
            1
          );
        }
      }
      if (this.skuSearch) {
        this.selectedGoodsList.forEach((e, i) => {
          if (e.skuId === item.skuId) {
            this.selectedGoodsList.splice(i, 1);
          }
        });
      } else {
        this.selectedGoodsList.forEach((e) => {
          if (e.wareId === item.wareId) {
            this.selectedGoodsList.splice(i, 1);
          }
        });
      }
      // this.selectedGoodsList.splice(index, 1);
      this.sliceArr(this.currentRightPage, this.pageSizeRight);
    },
    /**
     * 清空
     */
    empty() {
      // return
      if (this.disabled) return;
      if (this.skuSearch) {
        this.goodsList.forEach((item, index) => {
          if (this.ids.includes(item.skuId+'')) {
            item.isAdd = false;
          }
        });
      } else {
        this.goodsList.forEach((item, index) => {
          if (this.ids.includes(item.wareId+'')) {
            item.isAdd = false;
          }
        });
      }
      if(this.isClear&&this.hasSelectGoods.length>0) { 
        this.selectedGoodsList = this.hasSelectGoods.map((item) => {
          this.allShopList.forEach((i) => {
            if(i.skuId != item.skuId) {
              i.isAdd = false;
            } else {
              i.isAdd = true;
            }
          });
          return {...item,isAdd: true}
        });
        this.ids = this.hasSelectGoods.map((i) => {
          if (i.skuId) {
            return i.skuId + "";
          } else {
            return i.wareId + "";
          }
        });
        this.goodsList.forEach((item, index) => {
          if (this.ids.includes(item.skuId+'')) {
            item.isAdd = true;
          }
        });
      } else {
        this.allShopList.forEach((item) => {
          item.isAdd = false;
        });
        this.ids = [];
        this.selectedGoodsList = [];
        this.showSelectedGoodsList = [];
      }
      this.currentRightPage = 1;
    },
    /**
     * 右边商品盒子分页事件
     */
    handleRigthSizeChange(val) {
      this.pageSizeRight = val;
      // 分页size大于右商品盒子数组长度时
      if (
        this.currentRightPage * this.pageSizeRight >
        this.selectedGoodsList.length
      ) {
        this.sliceArr(1, this.selectedGoodsList.length);
      } else {
        this.sliceArr(1, val);
      }
    },
    // 右边商品盒子页码事件
    handleRightCurrentChange(val) {
      this.currentRightPage = val;
      this.sliceArr(val, this.pageSizeRight);
    },
    // 根据分页信息截取数组进行显示
    sliceArr(current, size) {
      this.showSelectedGoodsList = this.selectedGoodsList.slice(
        size * (current - 1),
        size * current
      );
      console.log(this.showSelectedGoodsList);
    },
    // 通过skuIds字符串获取商品信息
    getGoodsBySkuIds(skuIdsStr) {
      if (!skuIdsStr) return;

      // 显示加载状态
      this.tableLoading = true;

      // 构建查询参数
      const skuIds = skuIdsStr
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id);
      if (skuIds.length === 0) return;

      // 使用已有的API获取商品信息
      this.selectedGoodsLoading = true;
      // 单个商品使用skuId字段，多个商品使用skuIdStr字段
      const params = {
        size: skuIds.length,
        current: 1,
        venderId: this.venderId || undefined,
      };
      if (skuIds.length === 1) {
        params.skuId = skuIds[0];
      } else {
        params.skuIdStr = skuIds.join(",");
      }
      this.getTaobaoItemListSku(params)
        .then((res) => {
          this.tableLoading = false;
          this.selectedGoodsLoading = false;

          if (res.code == 1 && res.data && res.data.records) {
            // 处理返回的商品数据
            const goodsList = res.data.records.map((item) => {
              return {
                skuId: item.skuId,
                logo: item.logo,
                price: item.jdPrice || item.price,
                title: item.skuName || item.wareTitle,
                wareTitle: item.skuName || item.wareTitle,
                jdPrice: item.jdPrice || item.price,
                isAdd: true, // 标记为已添加
              };
            });

            // 更新已选商品列表
            this.selectedGoodsList = goodsList;
            this.showSelectedGoodsList = [...goodsList];

            // 更新已选ID列表
            this.ids = goodsList.map((item) =>item.skuId+'');

            // 更新左侧商品列表的选中状态
            this.$nextTick(() => {
              this.goodsList.forEach((item) => {
                if (this.ids.includes(item.skuId+'')) {
                  item.isAdd = true;
                }
              });
            });

            console.log("通过skuIds获取到的商品:", goodsList);
          } else {
            this.$message.warning(res.message || "获取商品信息失败");
          }
        })
        .catch((err) => {
          this.tableLoading = false;
          this.selectedGoodsLoading = false;
          console.error("获取商品信息失败:", err);
          this.$message.error("获取商品信息失败");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  margin: 0;
  padding: 0 12px;
  height: 32px;
  line-height: 30px;
  border: none;
  outline: none;
  border-radius: 3px;
  background-color: #fff;
  text-align: center;
  cursor: pointer;
}
.headSearchForm {
  // margin-top: 20px;
}
.notData {
  text-align: center;
  color: #909399;
  margin-top: 20%;
}
.goodsContent {
  display: flex;
  align-items: center;
  justify-content: center;
  .left{
    flex: 1;
    margin-right: 12px;
  }
  .left,
  .right {
    width: 480px;
    .titleBox {
      position: relative;
      width: 100%;
      height: 48px;
      line-height: 48px;
      color: #1f1f1f;
      font-size: 14px;
      background: #f8f9fa;
      border-radius: 4px 4px 0px 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px;
      .tit {
        color: #1f1f1f;
        font-size: 14px;
      }
      .all,
      .clear {
        position: absolute;
        right: 10px;
        color: #2768ff;
        cursor: pointer;
      }
      .update {
        // margin-left: -200px;
        position: absolute;
        left: 10px;
        top: 4px;
        width: 70px;
        font-size: 14px;
        height: 28px;
        color: #ffffff;
        background-color: #2768ff;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #2768ff;
        }
      }
    }
    .goodsScrollBox {
      height: 334px;
      overflow: auto;
      position: relative;
      &::-webkit-scrollbar {
        width: 8px;
        height: 10px;
      }
      &::-webkit-scrollbar-track {
        background: rgba(246, 246, 246, 1);
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #ddd;
      }
      .goods {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        justify-content: space-between;
        padding: 0 12px;
        height: 64px;
        border-left: 1px solid #f3f3f3;
        border-right: 1px solid #f3f3f3;
        border-bottom: 1px solid #f3f3f3;
        transition: all 0.2s;
        position: relative;
        a {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          // padding: 0 16px;
          height: 64px;
          flex: 1;
        }
        .avar {
          flex-shrink: 0;
          width: 48px;
          height: 48px;
          background-color: #f9f9f9;
        }
        .desc {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin: 0 0 0 8px;
          .goodsName {
            color: #666666;
            font-size: 14px;
            margin: 0 0 8px 0;
            display: -webkit-box;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            // -webkit-line-clamp: 2;
            line-height: 15px;

            // display: -webkit-box;
            // -webkit-box-orient: vertica;
            // overflow: hidden;
            // text-overflow: ellipsis;
          }
          .foot {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .goodsId {
              font-size: 13px;
              color: #666666;
            }
            .money {
              font-size: 13px;
              color: #333333;
              margin-right: 16px;
            }
          }
        }
        .addIcon {
          flex-shrink: 0;
          width: 20px;
          height: 20px;
          cursor: pointer;
          transition: all 0.2s;
          position: absolute;
          top: 32px;
          right: 12px;
        }
        .clearIcon {
          flex-shrink: 0;
          width: 20px;
          height: 20px;
          cursor: pointer;
          position: absolute;
          top: 32px;
          right: 12px;
        }
      }
      .isAdd {
        background-color: #f9f9f9 !important;
        .addIcon,.clearIcon {
          opacity: 0.3;
          cursor: not-allowed;
        }
      }
      .noDataBox {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        span {
          display: block;
          margin-top: 8px;
        }
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
  .left {
  }
  .right {
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
  .cancel,
  .confirm {
    width: 98px;
    font-size: 14px;
    height: 32px;
  }
  .cancel {
    margin-right: 8px;
    color: #999999;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #2768ff;
      border: 1px solid #2768ff;
      background-color: #fff4f4;
    }
  }
  .confirm {
    color: #ffffff;
    background-color: #2768ff;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #2768ff;
    }
  }
}
</style>
<!-- <style lang="scss">
.el-select-dropdown {
  z-index: 3334 !important;
}
</style> -->
